export async function CloseModal() {
  window.$('.modal').modal('hide');
}
